export const stripeDataGridColumns = [
  { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  { key: 'Id', label: 'S No', sortable: true, sticky: true },
  { key: 'Stripe_Id', label: 'Transaction Id', sortable: true, sticky: true },
  { key: 'Payment_Type', label: 'Payment Type', sortable: true, sticky: false },
  { key: 'Payment_Source', label: 'Source', sortable: true, sticky: false },
  { key: 'Created_on', label: 'Creation On', sortable: true, sticky: false },
  { key: 'Available_on', label: 'Available On', sortable: true, sticky: false },
  { key: 'Amount', label: 'Amount', sortable: true, sticky: false },
  { key: 'TaskId', label: 'Task Id', sortable: true, sticky: false },
  {
    key: 'Transfer_group',
    label: 'Transfer Group',
    sortable: true,
    sticky: false,
  },
  { key: 'Payment_Dpt', label: 'Payment Dpt', sortable: true, sticky: false },
  {
    key: 'ShopperEmail',
    label: 'Shopper Email',
    sortable: true,
    sticky: false,
  },
  { key: 'StatusText', label: 'Status', sortable: true, sticky: false },
  {
    key: 'ImportCounter',
    label: 'Import Count',
    sortable: true,
    sticky: false,
  },
  {
    key: 'Created_date',
    label: 'Creation Date',
    sortable: true,
    sticky: false,
  },
  { key: 'Created_by', label: 'Creation By', sortable: true, sticky: false },
  { key: 'Currency', label: 'Currency', sortable: true, sticky: false },
  { key: 'Description', label: 'Description', sortable: true, sticky: false },
  { key: 'Journal', label: 'Journal', sortable: true, sticky: false },
  { key: 'Ledger', label: 'Ledger', sortable: true, sticky: false },
  {
    key: 'Modified_date',
    label: 'Modified Date',
    sortable: true,
    sticky: false,
  },
  { key: 'Remarks', label: 'Remarks', sortable: true, sticky: false },
  { key: 'Remarks2', label: 'Remarks 2', sortable: true, sticky: false },
  {
    key: 'Transfer_Date',
    label: 'Transfer Date',
    sortable: true,
    sticky: false,
  },
  //{ key: 'actions', label: 'Actions' } // for buttons like Save, Edit, Delete
];
